import Vue from 'vue';

// v-dialogDrag: 拖拽属性 （重点！！！ 给模态框添加这个属性模态框就能拖拽了）
Vue.directive('dialogDrag', { //属性名称dialogDrag，前面加v- 使用
	bind(el, binding, vnode, oldVnode) {
		const dialogHeaderEl = el.querySelector('.ant-modal-header');
		const dragDom = el.querySelector('.ant-modal-content');
        const screenWidth = document.body.clientWidth; // body当前宽度
        const screenHeight = document.documentElement.clientHeight; // 可见区域高度(应为body高度，可某些环境下无法获取)
		//dialogHeaderEl.style.cursor = 'move';
		dialogHeaderEl.style.cssText += ';cursor:move;'
        // 定义鼠标可移动距离
        var moveYTop = 100;
        var moveYBottom = screenHeight - dragDom.offsetHeight -100;
        var moveXLeft = (screenWidth - dialogHeaderEl.offsetWidth)/2;
        var moveXRight = (screenWidth - dialogHeaderEl.offsetWidth)/2;
        
		// 获取原有属性 ie dom元素.currentStyle 火狐谷歌 window.getComputedStyle(dom元素, null);
		const sty = (function() {
			if (window.document.currentStyle) {
				return (dom, attr) => dom.currentStyle[attr];
			} else {
				return (dom, attr) => getComputedStyle(dom, false)[attr];
			}
		})()

		dialogHeaderEl.onmousedown = (e) => {
			
            // 记录鼠标点下的位置
            const downLeft = e.clientX;
            const downTop = e.clientY;
            
			document.onmousemove = function(e) {
				// 通过事件委托，计算移动的距离
				let left = e.clientX - downLeft;
				let top = e.clientY - downTop;

				// 边界处理
				if (left < 0 && Math.abs(left) > moveXLeft) {
                    left = -(moveXLeft);
				}else if (left >= 0 && Math.abs(left) > moveXRight){
                    left = moveXRight;
                }

				if (top < 0 && Math.abs(top) > moveYTop) {
					top = -(moveYTop);
                 
				} else if (top >= 0 && Math.abs(top) > moveYBottom) {
					top = moveYBottom;
                   
				}
                

				// 移动当前元素
				dragDom.style.cssText += `;transform:translate(${left}px,${top}px)`;
			};

			document.onmouseup = function(e) {
				
                //计算当前位置
                let left = e.clientX - downLeft;
				let top = e.clientY - downTop;
                if(top > 0){
                    if(top > moveYBottom) {
                        top = moveYBottom
                    }
                }else {
                    if(-top > moveYTop) {
                        top = -moveYTop
                    }
                   
                }
                if(left > 0){
                    if(left > moveXRight) {
                        left = moveXRight
                    }
                }else {
                    if(-left > moveXLeft) {
                        left = -moveXLeft
                    }
                }
                moveYBottom -= top;
                moveYTop += top;
                moveXLeft += left;
                moveXRight -= left;
                document.onmousemove = null;
				document.onmouseup = null;
                // 改变初始位置,以便相对定位
                dragDom.style.transform ='none'
                var initLeft = parseFloat(dragDom.style.left || 0)
                var initTop = parseFloat(dragDom.style.top || 0)
                dragDom.style.cssText += `;left:${initLeft + left}px;top:${initTop + top}px`
                
               
			};
		}
	}
})

